import { render, staticRenderFns } from "./handle-cer-completion.vue?vue&type=template&id=779454aa"
import script from "./handle-cer-completion.vue?vue&type=script&lang=js"
export * from "./handle-cer-completion.vue?vue&type=script&lang=js"
import style0 from "./handle-cer-completion.vue?vue&type=style&index=0&id=779454aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports